import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row justify-content-space-between p-r-16 p-l-16" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Exit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_chip = _resolveComponent("app-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_chip, {
      color: _ctx.ButtonColor.DANGER,
      pattern: _ctx.ButtonColorPattern.TRANSPARENT,
      onClick: _ctx.onExit
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["color", "pattern", "onClick"]),
    _createVNode(_component_app_chip, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.callTime), 1)
      ]),
      _: 1
    })
  ]))
}